// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qYkzyQQTAnMZhKEMOGOB {
    display: inline-block;
    position: relative;
    width: 5rem;
    height: 5rem;
  }
  
  .vRS2HGoBncUmBQyVStsA {
    position: absolute;
    width: 0.5rem;
    height: 0.5rem;
    background: #0f0a1b;
    border-radius: 50%;
    animation: qYkzyQQTAnMZhKEMOGOB 1.2s linear infinite
  }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(1) {
      animation-delay: 0s;
      top: 2.3125rem;
      left: 4.125rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(2) {
      animation-delay: -0.1s;
      top: 1.375rem;
      left: 3.875rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(3) {
      animation-delay: -0.2s;
      top: 0.6875rem;
      left: 3.25rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(4) {
      animation-delay: -0.3s;
      top: 0.4375rem;
      left: 2.3125rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(5) {
      animation-delay: -0.4s;
      top: 0.6875rem;
      left: 1.375rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(6) {
      animation-delay: -0.5s;
      top: 1.375rem;
      left: 0.6875rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(7) {
      animation-delay: -0.6s;
      top: 2.3125rem;
      left: 0.4375rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(8) {
      animation-delay: -0.7s;
      top: 3.25rem;
      left: 0.6875rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(9) {
      animation-delay: -0.8s;
      top: 3.875rem;
      left: 1.375rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(10) {
      animation-delay: -0.9s;
      top: 4.125rem;
      left: 2.3125rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(11) {
      animation-delay: -1s;
      top: 3.875rem;
      left: 3.25rem;
    }
  
  .vRS2HGoBncUmBQyVStsA:nth-child(12) {
      animation-delay: -1.1s;
      top: 3.25rem;
      left: 3.875rem;
    }

  .e3Wn4_XN8Y0QGuJhgNlv.qYkzyQQTAnMZhKEMOGOB {
      width: 1.25rem;
      height: 1.25rem;
    }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA {
      width: 0.11875rem;
      height: 0.11875rem
    }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(1) {
        top: 0.57813rem;
        left: 1.03125rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(2) {
        top: 0.34375rem;
        left: 0.96875rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(3) {
        top: 0.17188rem;
        left: 0.8125rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(4) {
        top: 0.10938rem;
        left: 0.57813rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(5) {
        top: 0.17188rem;
        left: 0.34375rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(6) {
        top: 0.34375rem;
        left: 0.17188rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(7) {
        top: 0.57813rem;
        left: 0.10938rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(8) {
        top: 0.8125rem;
        left: 0.17188rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(9) {
        top: 0.96875rem;
        left: 0.34375rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(10) {
        top: 1.03125rem;
        left: 0.57813rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(11) {
        top: 0.96875rem;
        left: 0.8125rem;
      }

  .e3Wn4_XN8Y0QGuJhgNlv .vRS2HGoBncUmBQyVStsA:nth-child(12) {
        top: 0.8125rem;
        left: 0.96875rem;
      }

  @keyframes qYkzyQQTAnMZhKEMOGOB {
    0%,
    20%,
    80%,
    100% {
      transform: scale(1);
    }
  
    50% {
      transform: scale(1.5);
    }
  }
  `, "",{"version":3,"sources":["webpack://./node_modules/@nxte-nl/loader/src/Loader.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAU;IACV,cAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB;EAyEF;;EAvEE;MACE,mBAAmB;MACnB,cAAS;MACT,cAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,aAAS;MACT,cAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,cAAS;MACT,aAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,cAAQ;MACR,eAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,cAAS;MACT,cAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,aAAS;MACT,eAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,cAAS;MACT,eAAS;IACX;;EAEA;MACE,sBAAsB;MACtB,YAAS;MACT,eAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,aAAS;MACT,cAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,aAAS;MACT,eAAU;IACZ;;EAEA;MACE,oBAAoB;MACpB,aAAS;MACT,aAAU;IACZ;;EAEA;MACE,sBAAsB;MACtB,YAAS;MACT,cAAU;IACZ;;EAIA;MACE,cAAW;MACX,eAAY;IACd;;EAEA;MACE,iBAAY;MACZ;IA6DF;;EA3DE;QACE,eAAW;QACX,gBAAY;MACd;;EAEA;QACE,eAAU;QACV,gBAAY;MACd;;EAEA;QACE,eAAW;QACX,eAAU;MACZ;;EAEA;QACE,eAAW;QACX,gBAAY;MACd;;EAEA;QACE,eAAW;QACX,gBAAW;MACb;;EAEA;QACE,eAAU;QACV,gBAAY;MACd;;EAEA;QACE,eAAW;QACX,gBAAY;MACd;;EAEA;QACE,cAAS;QACT,gBAAY;MACd;;EAEA;QACE,eAAW;QACX,gBAAW;MACb;;EAEA;QACE,eAAW;QACX,gBAAY;MACd;;EAEA;QACE,eAAW;QACX,eAAU;MACZ;;EAEA;QACE,cAAS;QACT,gBAAY;MACd;;EAIJ;IACE;;;;MAIE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;EACF","sourcesContent":[".loader {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n  }\n  \n  .loaderItem {\n    position: absolute;\n    width: 8px;\n    height: 8px;\n    background: #0f0a1b;\n    border-radius: 50%;\n    animation: loader 1.2s linear infinite;\n  \n    &:nth-child(1) {\n      animation-delay: 0s;\n      top: 37px;\n      left: 66px;\n    }\n  \n    &:nth-child(2) {\n      animation-delay: -0.1s;\n      top: 22px;\n      left: 62px;\n    }\n  \n    &:nth-child(3) {\n      animation-delay: -0.2s;\n      top: 11px;\n      left: 52px;\n    }\n  \n    &:nth-child(4) {\n      animation-delay: -0.3s;\n      top: 7px;\n      left: 37px;\n    }\n  \n    &:nth-child(5) {\n      animation-delay: -0.4s;\n      top: 11px;\n      left: 22px;\n    }\n  \n    &:nth-child(6) {\n      animation-delay: -0.5s;\n      top: 22px;\n      left: 11px;\n    }\n  \n    &:nth-child(7) {\n      animation-delay: -0.6s;\n      top: 37px;\n      left: 7px;\n    }\n  \n    &:nth-child(8) {\n      animation-delay: -0.7s;\n      top: 52px;\n      left: 11px;\n    }\n  \n    &:nth-child(9) {\n      animation-delay: -0.8s;\n      top: 62px;\n      left: 22px;\n    }\n  \n    &:nth-child(10) {\n      animation-delay: -0.9s;\n      top: 66px;\n      left: 37px;\n    }\n  \n    &:nth-child(11) {\n      animation-delay: -1s;\n      top: 62px;\n      left: 52px;\n    }\n  \n    &:nth-child(12) {\n      animation-delay: -1.1s;\n      top: 52px;\n      left: 62px;\n    }\n  }\n\n  .smallSize {\n    &.loader {\n      width: 20px;\n      height: 20px;\n    }\n    \n    & .loaderItem {\n      width: 1.9px;\n      height: 1.9px;\n    \n      &:nth-child(1) {\n        top: 9.25px;\n        left: 16.5px;\n      }\n    \n      &:nth-child(2) {\n        top: 5.5px;\n        left: 15.5px;\n      }\n    \n      &:nth-child(3) {\n        top: 2.75px;\n        left: 13px;\n      }\n    \n      &:nth-child(4) {\n        top: 1.75px;\n        left: 9.25px;\n      }\n    \n      &:nth-child(5) {\n        top: 2.75px;\n        left: 5.5px;\n      }\n    \n      &:nth-child(6) {\n        top: 5.5px;\n        left: 2.75px;\n      }\n    \n      &:nth-child(7) {\n        top: 9.25px;\n        left: 1.75px;\n      }\n    \n      &:nth-child(8) {\n        top: 13px;\n        left: 2.75px;\n      }\n    \n      &:nth-child(9) {\n        top: 15.5px;\n        left: 5.5px;\n      }\n    \n      &:nth-child(10) {\n        top: 16.5px;\n        left: 9.25px;\n      }\n    \n      &:nth-child(11) {\n        top: 15.5px;\n        left: 13px;\n      }\n    \n      &:nth-child(12) {\n        top: 13px;\n        left: 15.5px;\n      }\n    }\n  }\n\n  @keyframes loader {\n    0%,\n    20%,\n    80%,\n    100% {\n      transform: scale(1);\n    }\n  \n    50% {\n      transform: scale(1.5);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `qYkzyQQTAnMZhKEMOGOB`,
	"loaderItem": `vRS2HGoBncUmBQyVStsA`,
	"smallSize": `e3Wn4_XN8Y0QGuJhgNlv`
};
export default ___CSS_LOADER_EXPORT___;
